import { render, staticRenderFns } from "./taskClassConf.vue?vue&type=template&id=023a9855&scoped=true"
import script from "./taskClassConf.vue?vue&type=script&lang=js"
export * from "./taskClassConf.vue?vue&type=script&lang=js"
import style0 from "./taskClassConf.vue?vue&type=style&index=0&id=023a9855&prod&scoped=true&lang=css"
import style1 from "./taskClassConf.vue?vue&type=style&index=1&id=023a9855&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023a9855",
  null
  
)

export default component.exports